module.exports = __webpack_public_path__ + "img/pupa.871d7e05.svg";